module.exports = __webpack_public_path__ + "static/media/icon-check.dc88c5c2.png";